import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { Api } from "../axios-config"
import { IDadosJogadores } from "../propostas/PropostaService";

export interface IFranquia {
    codigo: number;
    nome: string;
    codigo_liga: number;
}


export interface ILstDrop {
    codigo: number;
    label: string;
    outros?: string;
    descricao?: string;
}

export interface ILstDropAtivosProposta {
    codigo: number;
    label: string;
    outros?: string;
    valor?: string;
    descricao?: string;
    tipo_Multa?: number;
    quantidade_Anos_Multa?: number;
    codigoTemporada?: number;
    rodada?: number;
}



interface IDadosRetornoFranquias {
    dado: IDetalheFranquia[];
}

interface IDadosRetornoFranquiasNBA {
    dado: IDetalheFranquiaNBA[];
}


export interface IDetalheFranquiaNBA {
    codigo: number;
    codigo_NBA: number;
    nome: string;
    cidade: number;
    sigla: string;
    ano_Fundacao: string;
    conferencia: string;
    logo: string;
    dtCriacao: Date;
    codUsuCriacao: number

}

export interface IDadosRetornoFranquia {
    dado: IDetalheFranquia;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosAtualizarGM {
    codigo: number;
    codigo_Usuario_GM: number;
    codigo_Usuario_Atribuicao: number;
    comissario: boolean;
    codUsuModificacao: number;

}


export interface IDetalheFranquia {
    codigo: number;
    nome: string;
    cidade: number;
    franquia_Franquia: string;
    codigo_Usuario: number;
    nome_Usuario: string;
    codUsuCriacao: number;
    codigo_liga: number;
    caminho_Logo: string; //"https://cdn.nba.com/headshots/nba/latest/1040x760/1630173.png"
    logo: string; //"https://cdn.nba.com/headshots/nba/latest/1040x760/1630173.png"
    dtCriacao: Date;
    situacao: number;
    capacidade_Maxima: string;
    capacidade_Restante: string;
    capacidade_Draft: string;
    espaco_Maximo: string;
    espaco_Restante: string;
    uniforme: string; //imagem
    codigo_Divisao: number;
    comissario: boolean;
    franquia_Jogador: IDadosFranquiaJogador[];
    franquia_Titulos: IDadosTitulosJogador[];
    franquia_Multas_Anual: IDadosFranquiaMultasAnual;
    codUsuModificacao?: number;
    irregularidades: string[];
    resumo_Picks_Ano1: IDadosResumoPicksAno[];
    resumo_Picks_Ano2: IDadosResumoPicksAno[];
    resumo_Picks_Ano3: IDadosResumoPicksAno[];
    resumo_Picks_Ano4: IDadosResumoPicksAno[];
    resumo_Picks_Ano5: IDadosResumoPicksAno[];
    codigo_Temporada: number;
}

export interface IDadosResumoPicksAno {
    codigo: number;
    swap: boolean;
    protecao: boolean;
    resumo: string;
    resumo_Swap: boolean;
    resumo_Protecao: boolean;
    inicio_Protecao: number;
    fim_Protecao: number;
    codigo_Franquia_Melhor_Pick_Swap: number;
    nome_Franquia_Melhor_Pick_Swap: string;
    logo_Franquia_Melhor_Pick_Swap: string;

}

export interface IDadosFranquiaMultasAnual {
    multa_Ano1: string;
    multa_Ano2: string;
    multa_Ano3: string;
    multa_Ano4: string;
    multa_Ano5: string;

}

export interface IDadosFranquiaJogador {
    codigo_Franquia: number;
    codigo_Jogador: number;
    nome_Jogador: string;
    foto_Jogador: string;
    posicao_Jogador: string;
    salario_1: string;
    salario_2: string;
    salario_3: string;
    salario_4: string;
    salario_5: string;
    tipo_Salario_1: number;
    tipo_Salario_2?: number;
    tipo_Salario_3?: number;
    tipo_Salario_4?: number;
    tipo_Salario_5?: number;
    posicao_1: string;
    posicao_2: string;
    posicao_3: string;
    contundido: boolean;
    dtContusao: Date;
    dtRetorno_Contusao: Date;
    draftado: boolean;
    fora_NBA: boolean;
    restrito: boolean;
    dtCriacao: Date;
    codUsuCriacao: number;
    codigo_posicao_1: string;
    codigo_posicao_2: string;
    codigo_posicao_3: string;
    codigo_Tipo_Ativo_Troca?: number;
}


export interface IDadosTitulosJogador {
    codigo: number;
    codigo_Franquia: number;
    codigo_Temporada: number;
    codigo_Divisao?: number;
    codigo_Conferencia?: number;
    codigo_Liga?: number;
    copinha: boolean;
    dtCriacao: Date;
    codUsuCriacao: number;
}

export interface IListagemFranquia {
    codigo: number;
    nome: string;
    franquia_Franquia?: string;
    codigo_Usuario?: number;
    codUsuCriacao?: number;
    codigo_Liga: number;
    nome_Liga: string;
    logo: string; //"https://cdn.nba.com/headshots/nba/latest/1040x760/1630173.png"
    dtCriacao?: Date;
    situacao?: number;
    cap_Maximo?: string;
    espaco_Maximo?: string;
    uniforme?: string; //imagem
    codigo_Divisao?: number;
    comissario?: boolean;
}

export interface IDadosRetornoListaFranquia {
    dado: IListagemFranquia[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetornoEdicao {
    dado: IDetalheFranquia;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

// interface RespostaCreate {
//     statusHTTP: number;
//     status: number;
//     processado: boolean;
//     erros: string;
//     mensagem: string;
//     dado: number;
// }

export interface IDadosRetornoImagemFranquia {
    data: {
        dado: IDadosRespImagemFranquia;
        erros: string;
        mensagem: string;
        processado: boolean;
        status: number;
        statusHTTP: number;
    }
}

export interface IDadosSimulacaoDispensaJogador {
    multa_Ano1: string;
    descricao_Multa_Ano1: string;
    multa_Ano2: string;
    descricao_Multa_Ano2: string;
    multa_Ano3: string;
    descricao_Multa_Ano3: string;
    multa_Ano4: string;
    descricao_Multa_Ano4: string;
    multa_Ano5: string;
    descricao_Multa_Ano5: string;

}

export interface IDadosRespImagemFranquia {
    caminho: string;
    nome: string;
    nomeReal: string;
}

type TFranquiasComTotalCount = {
    data: IDadosRetornoListaFranquia;
    totalCount: number;
}

export interface IDadosRetornoSimulacaoDispensaJogador {
    dado: IDadosSimulacaoDispensaJogador;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetornoMultasJogador {
    dado: IDadosMultasJogador[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosMultasJogador {
    foto_Jogador: string;
    multa_Ano1: string;
    descricao_Multa_Ano1: string;
    multa_Ano2: string;
    descricao_Multa_Ano2: string;
    multa_Ano3: string;
    descricao_Multa_Ano3: string;
    multa_Ano4: string;
    descricao_Multa_Ano4: string;
    multa_Ano5: string;
    descricao_Multa_Ano5: string;
    nome_Jogador: string;
}

export interface IDadosPosicaoJogador {
    foto: string;
    nome: string;
    codigo_Jogador: number;
    codigo_Posicao: number | undefined;
}

export interface IListaDadosEscalacao {
    codigo: number;
    dadosEscalacao: IDadosEscalacao[];
}

export interface IDadosEscalacao {
    codigo_Calendario: number;
    codigo_Franquia: number;
    codigo_Posicao_Conversao: number | undefined;
    escalacao_Jogador: IDetalheFranquiaEscalacao[];
    codUsuCriacao?: number;

}

export interface IDetalheFranquiaEscalacao {
    codigo?: number;
    codigo_Jogador: number | undefined;
    ordem: number; //titula, primeiro reserva, segundo e terceiro
    posicao_1?: number;
    posicao_2?: number;
    posicao_3?: number;


}

export interface IListaEscalacao {
    codigo: number;
    codigo_Calendario: number;
    codigo_Franquia: number;
    codigo_Posicao_Conversao: number;
    dtCriacao: Date;
    codUsuCriacao: number;
    escalacao_Jogador: IListaDadosEscalacaoJogador[]

}

export interface IListaDadosEscalacaoJogador {
    codigo: number;
    codigo_Escalacao: number;
    codigo_Jogador: number;
    ordem: number;
    posicao_1: number;
    posicao_2: number;
    posicao_3: number;
    dtCriacao: Date;
    codUsuCriacao: number;
    nome: string;
    foto: string;
}


export interface IDadosRetornoEscalacaoListaAmericana {
    dado: IDadosEscalacaoListaAmericana;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosEscalacaoListaAmericana {
    codigo_Calendario: number;
    codigo_Franquia: number;
    escalacao: IListaEscalacao[];
    reserva: IDadosRetornoEscalacaoFranquiaListaAmericana[];
    jogadores: IDadosRetornoEscalacaoFranquiaListaAmericana[];
    codUsuCriacao?: number;
}

export interface ICreateEscalacaoListaAmericana {
    codigo_Calendario: number;
    codigo_Franquia: number;
    escalacao: IDadosEscalacao[];
    reserva: IDadosRetornoEscalacaoFranquiaListaAmericana[];
    codUsuCriacao?: number;
}


export interface IDadosJogadoresFavorito {
    codigo_Liga: number;
    codigo_Franquia: number;
    codigo_Jogador: number;
    codUsuCriacao?: number;

}

export interface IDadosRetornoEscalacao {
    dado: IDadosRetornoEscalacaoFranquia;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetornoEscalacaoFranquia {
    escalacao: IListaEscalacao[];
    codigo_Franquia: number;
    nome_Franquia: string;
    logo_Franquia: string;
}


export interface IDadosRetornoEscalacaoPontuacao {
    dado: IEscalacaoPontuacao;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IEscalacaoPontuacao {
    codigo_Franquia: number;
    nome_Franquia: string;
    logo_Franquia: string;
    codigo_Liga: number;
    nome_Liga: string;
    logo_Liga: string;
    codigo_Calendario: number;
    escalacao_Realizada: boolean;
    escalacao: IDadosRetornoEscalacaoFranquiaPontuacao[];

}

export interface IDadosRetornoEscalacaoFranquiaPontuacao {
    codigo: number;
    codigo_Jogador: number;
    ordem: number;
    posicao_1: string;
    posicao_2: string | null;
    posicao_3: string | null;
    dtCriacao: Date;
    codUsuCriacao: number;
    nome_Jogador: string;
    foto_Jogador: string;
    playOff: boolean;
    escalacao_Apta: boolean;
    peso_Total: number;
    peso_Total_Minutos: number;
    media_Minutos: number;

}

export interface IDadosRetornoEscalacaoFranquiaListaAmericana {
    codigo: number;
    codigo_Jogador: number;
    ordem: number;
    posicao_1: string;
    posicao_2: string | null;
    posicao_3: string | null;
    dtCriacao: Date;
    codUsuCriacao: number;
    nome_Jogador: string;
    foto_Jogador: string;
    playOff: boolean;
    escalacao_Apta: boolean;
    peso_Total: number;
    peso_Total_Minutos: number;
    media_Minutos: number;
    ast?: number;
    blk?: number;
    dreb?: number;
    fga?: number;
    fgm?: number;
    fgmp?: number;
    fta?: number;
    ftm?: number;
    ftmp?: number;
    min?: number;
    mplu?: number
    oreb?: number;
    peso_Total_Jogador?: number;
    pf?: number;
    posicao_Liga?: string;
    posicao_Original?: string;
    pts?: number;
    quantidade_Jogos?: number;
    reb?: number;
    stl?: number;
    threepa?: number;
    threepm?: number;
    threepmp?: number;
    to?: number;
    fgM_Informativo?: number;
    fgA_Informativo?: number;
    ftM_Informativo?: number;
    ftA_Informativo?: number;
    threepM_Informativo?: number;
    threepA_Informativo?: number;
    fte?: number;
    fge?: number;
    threepe?: number;
    stocks?: number;

}

export interface IDadosTitulares {
    codigoJogador: number;
    posicao: string;

}

export interface IDadosEscalacaoPontuacao {
    codigo_Liga: number;
    codigo_Calendario: number;
    codigo_Franquia: number;
    codigo_Jogador: number;
    ordem: number;
    posicao_1: string;
    posicao_2: string | null;
    posicao_3: string | null;
    codUsuCriacao: number;
}

export interface IDadosDisponibilizacaoJogador {
    codigo_Franquia: number;
    codigo_Usuario: number;
    codigo_Jogador: number;
    codigo_Tipo_Ativo_Troca?: number | null;
}

export interface IListagemJogadoresDisponiveis {
    codigo_Jogador: number;
    nome_Jogador: string;
    foto_Jogador: string;
    primeiro_Nome: string;
    situacao: number;
    ultimo_Nome: string;
    posicao_Jogador_1: string;
    posicao_Jogador_2: string;
    posicao_Jogador_3: string;
    salario_Jogador: string;
    tempo_Contrato_Jogador: number;
    tempo_Contrato_Ultimo_Lance: number;
    codigo_Franquia: number;
    nome_Franquia: string;
    logo_Franquia: string;
    caminho_Logo_Franquia: string;
    codigo_Tipo_Ativo_Troca?: number | null;


}


export interface IDadosRetornoJogadorDisponivel {
    dado: IListagemJogadoresDisponiveis[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListagemJogadoresFavoritos {
    codigo_Jogador: number;
    nome_Jogador: string;
    foto_Jogador: string;
    primeiro_Nome: string;
    situacao: number;
    ultimo_Nome: string;
    posicao_Jogador_1: string;
    posicao_Jogador_2: string;
    posicao_Jogador_3: string;
    salario_Jogador: string;
    tempo_Contrato_Jogador: number;
    tempo_Contrato_Ultimo_Lance: number;
    codigo_Franquia: number;
    nome_Franquia: string;
    logo_Franquia: string;
    caminho_Logo_Franquia: string;
    codigo_Tipo_Ativo_Troca?: number | null;
    ast?: number;
    blk?: number;
    dreb?: number;
    fga?: number;
    fgm?: number;
    fgmp?: number;
    fta?: number;
    ftm?: number;
    ftmp?: number;
    min?: number;
    mplu?: number
    ordem?: number;
    oreb?: number;
    peso_Total_Jogador?: number;
    pf?: number;
    posicao_Liga?: string;
    posicao_Original?: string;
    pts?: number;
    quantidade_Jogos?: number;
    reb?: number;
    stl?: number;
    threepa?: number;
    threepm?: number;
    threepmp?: number;
    to?: number;
    fgM_Informativo?: number;
    fgA_Informativo?: number;
    ftM_Informativo?: number;
    ftA_Informativo?: number;
    threepM_Informativo?: number;
    threepA_Informativo?: number;
    setimo_Homem?: boolean;
    fte?: number;
    fge?: number;
    threepe?: number;
    stocks?: number;
    peso_Minutos_Jogador?: number;

}


export interface IDadosRetornoJogadorFavorito {
    dado: IListagemJogadoresFavoritos[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosExportMeuTime {
    codigo?: number;
    Nome: string;
    Posicao_1: string;
    Posicao_2?: string;
    Posicao_3?: string;
    foto?: string;
    ast?: number;
    blk?: number;
    dreb?: number;
    fga?: number;
    fgm?: number;
    fgmp?: number;
    fta?: number;
    ftm?: number;
    ftmp?: number;
    min?: number;
    mplu?: number
    ordem: number;
    oreb?: number;
    peso_Total_Jogador?: number;
    pf?: number;
    posicao_Liga?: string;
    posicao_Original?: string;
    pts?: number;
    quantidade_Jogos?: number;
    reb?: number;
    stl?: number;
    threepa?: number;
    threepm?: number;
    threepmp?: number;
    to?: number;
    setimo_Homem: boolean;
    fte?: number;
    fge?: number;
    threepe?: number;
    stocks?: number;
    salario_1: string;
    salario_2?: string;
    salario_3?: string;
    salario_4?: string;
    salario_5?: string;
}

export interface IDadosRetornoFranquiaTimesExcel {
    dado: IDadosExportMeuTime[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosContratoTwoWay {
    codigo_Liga: number;
    codigo_Franquia: number;
    codigo_Jogador: number;
    codigo_Usuario: number;
}

export interface IDadosPicks {
    codigo_Franquia: number;
    nome_Franquia: string;
    logo_Franquia: string;
    picks: IListaDadosPicks[];

}

export interface IListaDadosPicks {
    codigo: number;
    codigo_Temporada: number;
    descricao_Temporada: string;
    codigo_Franquia_Dono: number;
    nome_Franquia_Dono: string;
    logo_Franquia_Dono: string;
    codigo_Franquia_Original: number;
    nome_Franquia_Original: string;
    logo_Franquia_Original: string;
    rodada?: number | null;
    posicao_Final?: number | null;
    observacao: string;
}

export interface IDadosRetornoPicks {
    dado: IDadosPicks[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosDispensaHistorico {
    codigo_Jogador: number;
    codigo_Franquia: number;
    codigo_Temporada: number;
    data: string;
    codigo_Usuario: number;
    salario: string;
    multa: string;
    quantidade_Anos: number;
}

export interface IDadosCadastroPorFranquia {
    codigo_Liga: number;
    codigo_Jogador: number;
    codigo_Franquia: number;
    posicao_1?: string;
    posicao_2?: string;
    posicao_3?: string;
    quantidade_Anos_Contrato: number;
    salario_1: string;
    tipo_Salario_1: number;
    salario_2?: string | null;
    tipo_Salario_2?: number | null;
    salario_3?: string | null;
    tipo_Salario_3?: number | null;
    salario_4?: string | null;
    tipo_Salario_4?: number | null;
    salario_5?: string | null;
    tipo_Salario_5?: number | null;
    salario_6?: string | null;
    tipo_Salario_6?: number | null;
    restrito: boolean;
    draftado: boolean;
    codUsuCriacao: number;

}

interface RespostaCreate {
    statusHTTP: number;
    status: number;
    processado: boolean;
    erros: string;
    mensagem: string;
    dado: number;
}

const getAll = async (page = 1, filter = '', id = 0): Promise<TFranquiasComTotalCount> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/franquia/sql`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo: id > 0 ? id : null,
            NumeroPagina: page,
            TamanhoPagina: 30,
            Filtro: null,
            Filtro2: filter
        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };

}

const getAllFranquias = async (page = 1, filter = '', id = 0): Promise<TFranquiasComTotalCount> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/franquia/sql`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo: id > 0 ? id : null,
            NumeroPagina: page,
            TamanhoPagina: 30,
            Filtro: null,
            Filtro2: filter
        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };

}

const getById = async (codigo: number): Promise<IDetalheFranquia> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDetalheFranquia>(`/franquia/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getByIdLiga = async (codigo: number): Promise<IDadosRetornoFranquias> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoFranquias>(`/franquia/liga/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}


const getFranquiaNBA = async (): Promise<IDadosRetornoFranquiasNBA> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoFranquiasNBA>(`/franquia/nba`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getByIdUsuario = async (): Promise<TFranquiasComTotalCount> => {
    const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/franquia/usuario/${user.codUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getByIdLigaIdUsuario = async (codigoLiga: number): Promise<IDadosRetornoFranquia> => {

    const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoFranquia>(`/franquia/completo/${codigoLiga}/${user.codUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;

}

const getByIdLigaIdUsuarioToExcel = async (codigoFranquia: number, codigoLiga: number): Promise<IDadosRetornoFranquiaTimesExcel> => {

    const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoFranquiaTimesExcel>(`/franquia/jogador/exportacao/excel/${codigoFranquia}/${codigoLiga}/${user.codUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;

}

const getByIdFranquiaIdUsuario = async (codigoFranquia: number): Promise<IDadosRetornoFranquia> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoFranquia>(`/franquia/completo/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const Create = async (dados: Omit<IDetalheFranquia, "codigo">): Promise<number> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.post<IDetalheFranquia>(`/franquia`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data.codigo;
}


const CreateEscalacao = async (dados: IDadosEscalacao[]): Promise<number> => {
    // console.log("CreateEscalacao");
    // console.log(dados);
    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/franquia/escalacao`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const CreateEscalacaoListaAmericana = async (dados: ICreateEscalacaoListaAmericana): Promise<number> => {
    // console.log("CreateEscalacao");
    // console.log(dados);
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");
    dados.codUsuCriacao = user.codUsuario;
    const { data } = await Api.post(`/franquia/escalacao/americana/lista`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const CreateEscalacaoListaAmericanaPlayOffs = async (dados: ICreateEscalacaoListaAmericana): Promise<number> => {
    // console.log("CreateEscalacao");
    // console.log(dados);
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");
    dados.codUsuCriacao = user.codUsuario;
    const { data } = await Api.post(`/franquia/escalacao/americana/lista/playoff`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const CreateEscalacaoPontuacao = async (dados: IDadosEscalacaoPontuacao[]): Promise<number> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/franquia/escalacao/pontuacao`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const CreateEscalacaoPontuacaoPlayOffs = async (dados: IDadosEscalacaoPontuacao[]): Promise<number> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/franquia/escalacao/pontuacao/playoff`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const CreateEscalacaoPlayOffs = async (dados: IDadosEscalacao[]): Promise<number> => {
    // console.log("CreateEscalacao");
    // console.log(dados);
    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/franquia/escalacao/playoffs`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const CreateJogadorFavorito = async (dados: IDadosJogadoresFavorito): Promise<number> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");

    dados = { ...dados, codUsuCriacao: user.codUsuario };
    const { data } = await Api.post(`/franquia/cadastro/jogador/favorito`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data.codigo;
}

const getEscalacaoFranquia = async (codigoCalendario: number, codigoFranquia: number): Promise<IDadosRetornoEscalacao> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEscalacao>(`franquia/escalacao/${codigoCalendario}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getEscalacaoFranquiaPontuacao = async (codigoCalendario: number, codigoFranquia: number): Promise<IDadosRetornoEscalacaoPontuacao> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEscalacaoPontuacao>(`franquia/escalacao/pontuacao/${codigoCalendario}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getEscalacaoFranquiaListaAmericana = async (codigoCalendario: number, codigoFranquia: number): Promise<IDadosRetornoEscalacaoListaAmericana> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEscalacaoListaAmericana>(`franquia/escalacao/americana/lista/${codigoCalendario}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}


const getEscalacaoFranquiaListaAmericanaPlayOffs = async (codigoCalendario: number, codigoFranquia: number): Promise<IDadosRetornoEscalacaoListaAmericana> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEscalacaoListaAmericana>(`franquia/escalacao/americana/lista/playoff/${codigoCalendario}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getEscalacaoFranquiaPontuacaoPlayOffs = async (codigoCalendario: number, codigoFranquia: number): Promise<IDadosRetornoEscalacaoPontuacao> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEscalacaoPontuacao>(`franquia/escalacao/pontuacao/playoff/${codigoCalendario}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}


const getEscalacaoFranquiaPlayOffs = async (codigoCalendario: number, codigoFranquia: number): Promise<IDadosRetornoEscalacao> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEscalacao>(`franquia/escalacao/playoffs/${codigoCalendario}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getEscalacaoFranquiaImportacaoPlayOffs = async (codigoLiga: number, codigoTemporada: number, codigoFranquia: number): Promise<IDadosRetornoEscalacao> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEscalacao>(`franquia/escalacao/importacao/playoffs/${codigoLiga}/${codigoTemporada}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}


const updateById = async (dados: IDetalheFranquia): Promise<void> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");

    dados = { ...dados, codUsuModificacao: user.codUsuario };

    await Api.put<IDetalheFranquia>(`/franquia`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const updateByIdGmFranquia = async (dados: IDadosAtualizarGM): Promise<void> => {
    const token = CookieService.get("access_token");
    await Api.put<IDadosAtualizarGM>(`/franquia/usuariofranquia`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const updateByIdResumido = async (dados: IDetalheFranquia): Promise<void> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");

    dados = { ...dados, codUsuModificacao: user.codUsuario };

    await Api.put<IDetalheFranquia>(`/franquia/resumido`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const updateFranquiaTwoWay = async (codigoLiga: number, codigoFranquia: number, codigoJogador: number): Promise<void> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");

    let dados: IDadosContratoTwoWay = {
        codigo_Liga: codigoLiga,
        codigo_Franquia: codigoFranquia,
        codigo_Jogador: codigoJogador,
        codigo_Usuario: user.codUsuario
    };

    await Api.put<IDadosContratoTwoWay>(`/franquia/jogador/contrato/twoway`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const deleteById = async (codigo: number): Promise<void> => {
    const token = CookieService.get("access_token");
    await Api.delete(`/franquia/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const upLoadImage = async (image: any): Promise<IDadosRetornoImagemFranquia> => {

    const obj = CookieService.get("access_user");
    const idUsuario = obj.codUsuario;

    const formData = new FormData();
    formData.append('img', image);

    const token = CookieService.get("access_token");
    return await Api.post('/FileUpload/franquia/logo/upload', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            'Access-Control-Allow-Origin': '*',
            'chavesessao': token
        }
    }).then(res => res)
        .catch((error) => error.response);
}


const dispensarJogadorFranquia = async (codigoJogador: number, codigoFranquia: number): Promise<void> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");

    return await Api.delete(`/franquia/jogador/${codigoJogador}/${codigoFranquia}/${user.codUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const dispensarJogadorFranquiaHistorico = async (dadosDispensa: IDadosDispensaHistorico): Promise<void> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");

    return await Api.put(`/franquia/jogador/historico`, dadosDispensa, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}


const simularDispensaJogadorFranquia = async (codigoFranquia: number, codigoJogador: number): Promise<IDadosRetornoSimulacaoDispensaJogador> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");
    const { data } = await Api.get<IDadosRetornoSimulacaoDispensaJogador>(`/franquia/simular/jogador/${codigoJogador}/${codigoFranquia}/${user.codUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const disponibilizarJogador = async (dados: IDadosDisponibilizacaoJogador): Promise<void> => {
    const token = CookieService.get("access_token");

    return await Api.put(`/franquia/jogador/troca/intencao`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const getTodosJogadoresDisponiveis = async (page = 1, filter = '', codigoLiga = 0, codigoJogador: number | null, posicao: string | null | undefined, codigo_franquia: number | null, salario: string | null, codigoTipoAtivoTroca: number | null): Promise<IDadosRetornoJogadorDisponivel> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get("/franquia/jogador/troca/todos", {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo_Liga: codigoLiga > 0 ? codigoLiga : null,
            Codigo_Jogador: codigoJogador !== null && codigoJogador > 0 ? codigoJogador : null,
            Posicao_Jogador: posicao !== null ? posicao : null,
            Codigo_Franquia: codigo_franquia !== null ? codigo_franquia : null,
            Salario_Maximo: salario !== null ? salario : null,
            Codigo_Tipo_Ativo_Troca: codigoTipoAtivoTroca !== null ? codigoTipoAtivoTroca : null,
            NumeroPagina: page,
            TamanhoPagina: 1000,
            Filtro: null,
            Filtro2: filter
        }
    });

    return data;
}

const deleteJogadorFavoritoById = async (codigoJogador: number, codigoUsuario: number): Promise<void> => {
    const token = CookieService.get("access_token");
    await Api.delete(`/franquia/jogador/favorito/${codigoJogador}/${codigoUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}


const getJogadoresFavoritos = async (codigoJogador: number | null, posicao: string | null | undefined, codigoFranquia: number | null): Promise<IDadosRetornoJogadorFavorito> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/franquia/jogador/favorito/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        // params: {
        //     Codigo_Liga: codigoLiga > 0 ? codigoLiga : null,
        //     Codigo_Jogador: codigoJogador !== null && codigoJogador > 0 ? codigoJogador : null,
        //     Posicao_Jogador: posicao !== null ? posicao : null,
        //     Codigo_Franquia: codigoFranquia !== null ? codigoFranquia : null,
        //     Salario_Maximo: salario !== null ? salario : null,
        //     Codigo_Tipo_Ativo_Troca: codigoTipoAtivoTroca !== null ? codigoTipoAtivoTroca : null,
        //     NumeroPagina: page,
        //     TamanhoPagina: 1000,
        //     Filtro: null,
        //     Filtro2: filter
    }
    );

    return data;
}

const dadosDetalhadosMultasJogador = async (codigoFranquia: number): Promise<IDadosRetornoMultasJogador> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoMultasJogador>(`/franquia/multas/jogador/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getPicksPorLigaFranquiaTemporada = async (codigoLiga: number, codigoFranquia: number, codigoTemporada: number): Promise<IDadosRetornoPicks> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get("/franquia/picks/consulta", {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo_Liga: codigoLiga > 0 ? codigoLiga : null,
            Codigo_Franquia: codigoFranquia > 0 ? codigoFranquia : null,
            Codigo_Temporada: codigoTemporada > 0 ? codigoTemporada : null,
        }
    });

    return data;
}

const retornoDispensaJogador = async (codigoFranquia: number, codigoJogador: number, codigoUsuario: number): Promise<void> => {
    const token = CookieService.get("access_token");

    return await Api.put(`/franquia/jogador/retorno/${codigoJogador}/${codigoFranquia}/${codigoUsuario}`, null, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const CadastrarJogadorPorFranquia = async (dadosCadastro: Omit<IDadosCadastroPorFranquia, "codigo">): Promise<number> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");
    dadosCadastro.codUsuCriacao = user.codUsuario;

    const { data } = await Api.post<RespostaCreate>(`/franquia/cadastro/jogador`, dadosCadastro, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    if (data.processado) {
        return data.dado;
    }
    return 0;
}


export const FranquiaService = {
    getAll,
    getAllFranquias,
    getById,
    Create,
    updateById,
    deleteById,
    getByIdLiga,
    getByIdLigaIdUsuario,
    getByIdUsuario,
    upLoadImage,
    updateByIdResumido,
    simularDispensaJogadorFranquia,
    dispensarJogadorFranquia,
    dadosDetalhadosMultasJogador,
    getByIdFranquia: getByIdFranquiaIdUsuario,
    CreateEscalacao,
    getEscalacaoFranquia,
    updateByIdGmFranquia,
    CreateEscalacaoPlayOffs,
    getEscalacaoFranquiaPlayOffs,
    getEscalacaoFranquiaImportacaoPlayOffs,
    disponibilizarJogador,
    getTodosJogadoresDisponiveis,
    getFranquiaNBA,
    getEscalacaoFranquiaPontuacao,
    CreateEscalacaoPontuacao,
    getEscalacaoFranquiaPontuacaoPlayOffs,
    CreateEscalacaoPontuacaoPlayOffs,
    getByIdLigaIdUsuarioToExcel,
    updateFranquiaTwoWay,
    getPicksPorLigaFranquiaTemporada,
    dispensarJogadorFranquiaHistorico,
    getJogadoresFavoritos,
    CreateJogadorFavorito,
    CreateEscalacaoListaAmericana,
    getEscalacaoFranquiaListaAmericana,
    deleteJogadorFavoritoById,
    retornoDispensaJogador,
    CadastrarJogadorPorFranquia,
    CreateEscalacaoListaAmericanaPlayOffs,
    getEscalacaoFranquiaListaAmericanaPlayOffs

}